import { AnyAction, Dispatch, Middleware } from 'redux'
import { showGuestSignUpAction } from './actions'
import { IStoreState } from './states'
import { BusStopsStepTypeKeys } from './types'

/**
 * Every way of picking a stop ends in one of these actions, so this is the one place where a
 * guest is stopped: the stop is not picked and the sign up prompt opens instead. Screens keep
 * dispatching as usual and never need to know about guests.
 */
function picksAStop(action: any): boolean {
  switch (action.type) {
    case BusStopsStepTypeKeys.SET_BUS_STOP:
    case BusStopsStepTypeKeys.SET_SINGLE_BUS_STOP_DIRECTION:
      return true
    case BusStopsStepTypeKeys.SHOW_SINGLE_STOP_MODAL:
      // Opening the direction modal is a pick in progress; closing it is not.
      return !!action.payload?.isSingleStopModalOpen
    default:
      return false
  }
}

export const guestGuard: Middleware<{}, IStoreState> = store => next => (action: any) => {
  if (store.getState().userInfo.isGuest && picksAStop(action)) {
    return next(showGuestSignUpAction())
  }

  return next(action)
}

/**
 * Dispatches a pick and tells whether it went through. A screen that moves on right after picking
 * (a round trip stop goes straight to the date step) uses it to stay put when the guard turned the
 * pick into the sign up prompt — leaving the page would close the prompt at once.
 */
export function dispatchPick(dispatch: Dispatch<AnyAction>, action: AnyAction): boolean {
  return dispatch(action) === action
}
